import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../components/TourTypesSlider.css";  // import CSS file (styles below)

//Import Images

import tab1 from '../assets/image/tab1.svg';
import tab2 from '../assets/image/tab2.svg';
import tab3 from '../assets/image/tab3.svg';
import tab4 from '../assets/image/tab4.svg';
import tab5 from '../assets/image/tab5.svg';
import tab6 from '../assets/image/tab2.svg';
import tab7 from '../assets/image/tab1.svg';
import tab8 from '../assets/image/tab2.svg';
//Import Ta Content Images
import img1 from '../assets/image/img1.png';
import img2 from '../assets/image/img2.png';
import img3 from '../assets/image/img3.png';

import planeIcon from '../assets/image/plane.svg';
//Import Ta Content Images
import clockIcon from '../assets/image/clockIcon.svg';
import personIcon from '../assets/image/personIcon.svg';

import {ExploreArrowIcon , SliderRightArrow ,SliderLeftArrow} from './SvgIcons';

const categories = [
  { name: "Group Tour", img: tab1},
  { name: "Luxury Tour", img: tab2 },
  { name: "Honey moon Tour", img: tab3 },
  { name: "Cultural Tours", img: tab4 },
  { name: "Adventure Tours", img: tab5},
  { name: "Wildlife & Safari", img: tab6 },
  { name: "Beach Holidays", img: tab7 },
  { name: "Family Packages", img: tab8 },
];

const tourData = {
  "Group Tour": [
    {
      title: "Exploring Ancient Ruins, Historic Landmarks, And Culture.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$760",
      oldPrice: "$299",
      label: "Popular",
    },
    {
      title: "Cultural Highlights Expedition",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$820",
      oldPrice: "$299",
    },
    {
      title: "Historic Wonders Tour",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$920",
      oldPrice: "$299",
    },
  ],
  "Luxury Tour": [
    {
      title: "Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Honey moon Tour": [
    {
      title: " New Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Cultural Tours": [
    {
      title: "Cultural Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Adventure Tours": [
    {
      title: "Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Wildlife & Safari": [
    {
      title: "Wildlife & Safari Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Beach Holidays": [
    {
      title: " Beach Holidays Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  "Family Packages": [
    {
      title: "Family Packages Adventure Art, Architecture, And Mediterranean.",
      img: img1,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$170",
      oldPrice: "$299",
    },
    {
      title: "Luxury Cruise Through Coastal Cities.",
      img: img2,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$900",
      oldPrice: "$299",
    },
    {
      title: "Exquisite Wine & Dine Experience.",
      img: img3,
      days: "4 Days / 5 Nights",
      person: "2 Person",
      price: "$680",
      oldPrice: "$299",
    },
  ],
  // Add additional tourData items for the other categories similarly if needed...
};

const fallbackToursByCategory = tourData;

function normalizePrice(value) {
  if (value === null || value === undefined || value === '') {
    return '$149';
  }

  if (typeof value === 'number') {
    return `$${value}`;
  }

  const stringValue = String(value).trim();
  return stringValue.startsWith('$') || /inr|rs|₹/i.test(stringValue) ? stringValue : `$${stringValue}`;
}

const TourTabsSlider = ({ items = [], tours = [], onSelectTour = null }) => {
  const dynamicCategories = items.length
    ? items.map((item, index) => ({
        id: item.id,
        name: item.name,
        img: categories[index % categories.length].img,
      }))
    : categories;
  const dynamicTourData = items.length && tours.length
    ? items.reduce((carry, item, index) => {
        const matchedTours = tours
          .filter((tour) => Array.isArray(tour.categories) && tour.categories.some((category) => Number(category.id) === Number(item.id)))
          .map((tour) => ({
            title: tour.name,
            img: tour.image_url || [img1, img2, img3][index % 3],
            days: tour.duration || 'Custom Duration',
            person: tour.persons || '2 Person',
            price: normalizePrice(tour.price),
            oldPrice: tour.old_price || '$299',
            enquiryTour: tour.name || item.name,
          }));

        carry[item.name] = matchedTours.length ? matchedTours : [
          {
            title: item.name,
            img: [img1, img2, img3][index % 3],
            days: '4 Days / 5 Nights',
            person: '2 Person',
            price: '$760',
            oldPrice: '$299',
            enquiryTour: item.name,
          },
        ];

        return carry;
      }, {})
    : fallbackToursByCategory;
  const [activeTab, setActiveTab] = useState(dynamicCategories[0]?.name || categories[0].name);
  const sliderRef = useRef(null);

  // Width of one tab item (will compute dynamically)
  const [tabWidth, setTabWidth] = useState(0);

  // Drag-to-scroll state
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartScrollLeftRef = useRef(0);
  const [isDraggingClass, setIsDraggingClass] = useState(false);

  useEffect(() => {
    // After render, measure one tab's width (with margin)
    if (sliderRef.current) {
      const firstTab = sliderRef.current.querySelector(".nav-link");
      if (firstTab) {
        const style = window.getComputedStyle(firstTab);
        const marginRight = parseFloat(style.marginRight);
        const width = firstTab.offsetWidth + marginRight;
        setTabWidth(width);
      }
    }
  }, [dynamicCategories.length]);

  useEffect(() => {
    if (!dynamicCategories.find((category) => category.name === activeTab)) {
      setActiveTab(dynamicCategories[0]?.name || categories[0].name);
    }
  }, [activeTab, dynamicCategories]);

  const snapToNearest = (leftValue) => {
    if (tabWidth <= 0) return leftValue;
    const nearestIndex = Math.round(leftValue / tabWidth);
    return nearestIndex * tabWidth;
  };

  const handleSlide = (dir) => {
    if (!sliderRef.current) return;
    const currentLeft = sliderRef.current.scrollLeft;
    const delta = dir === "left" ? -tabWidth : tabWidth; // move exactly one tab
    const targetLeft = snapToNearest(currentLeft + delta);
    sliderRef.current.scrollTo({ left: targetLeft, behavior: "smooth" });
  };

  // Mouse drag handlers
  const onMouseDown = (e) => {
    if (!sliderRef.current) return;
    isDraggingRef.current = true;
    setIsDraggingClass(true);
    dragStartXRef.current = e.pageX;
    dragStartScrollLeftRef.current = sliderRef.current.scrollLeft;
  };

  const onMouseMove = (e) => {
    if (!isDraggingRef.current || !sliderRef.current) return;
    const deltaX = e.pageX - dragStartXRef.current;
    sliderRef.current.scrollLeft = dragStartScrollLeftRef.current - deltaX;
  };

  const endDrag = () => {
    if (!isDraggingRef.current) return;
    isDraggingRef.current = false;
    setIsDraggingClass(false);
    if (sliderRef.current) {
      const snappedLeft = snapToNearest(sliderRef.current.scrollLeft);
      sliderRef.current.scrollTo({ left: snappedLeft, behavior: "smooth" });
    }
  };

  return (
    <Container className="">
      {/* Tabs Slider */}
      <div className="tabs-wrapper position-relative mb-50">
        <button
          type="button"
          aria-label="Previous"
          className="tab-arrow custom shape-left position-absolute  top-50 translate-middle-y left-arrow"
          onClick={() => handleSlide("left")}
        >
          <SliderLeftArrow />
        </button>

        <div className="tabs-scroll-container overflow-hidden">
          <div
            ref={sliderRef}
            className={`tabs-track d-flex flex-nowrap nav nav-pills hide-scrollbar ${isDraggingClass ? 'dragging' : ''}`}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={endDrag}
            onMouseLeave={endDrag}
          >
            {dynamicCategories.map((cat) => (
              <button
                key={cat.name}
                type="button"
                className={`nav-link d-flex flex-column align-items-center justify-content-center text-center me-3 ${
                  activeTab === cat.name ? "active" : ""
                }`}
                onClick={() => setActiveTab(cat.name)}
              >
                <img src={cat.img} alt={cat.name} className="tab-icon" />
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <button
          type="button"
          aria-label="Next"
          className="tab-arrow custom shape-right position-absolute top-50 translate-middle-y right-arrow"
          onClick={() => handleSlide("right")}
        >
          <SliderRightArrow />
        </button>
      </div>

      {/* Tour Cards */}
      <Row className="tourTypes-card">
        {dynamicTourData[activeTab]?.map((item, idx) => (
          <Col md={6} lg={4} key={idx} className="mb-4">
            <Card className="shadow-sm border-0 h-100 ">
              <div className="position-relative">
              
                <Card.Img
                  variant="top"
                  src={item.img}
                  alt={item.title}
                  className="rounded-top"
                />
                <div className="position-absolute bottom-0 w-100 background-overlay text-white small d-flex justify-content-between" >
                  <span className="me-3">
                  <img src={clockIcon} alt="" className="icon me-1" /> {item.days}
                  </span>
                  <span>
                  <img src={personIcon} alt="" className="icon me-1" />  {item.person}
                  </span>
                </div>
              </div>
              <Card.Body className="p-0">
                <Card.Title className="fw-bold dark-black font-18 cardHeading tour-card">{item.title}</Card.Title>
                <div className="d-flex justify-content-between align-items-center card-border">
                  <div>
                   
                    <small className="text-decoration-line-through text-muted fw-semibold darkgray-text">
                      {item.oldPrice}
                    </small>
                    <h5 className="mb-0 fw-bold LightGreen-text">
                        {item.price}{" "}
                        <span className="fw-medium darkgray-text tourPerson">/ Per person</span>
                        </h5>
                  </div>
                  <Button
                    variant="link"
                    className="explore-btn fw-bold text-decoration-none"
                    onClick={() => {
                      if (typeof onSelectTour === 'function') {
                        onSelectTour(item.enquiryTour || item.title);
                      }
                    }}
                  >
                    Explore Now 
                    <ExploreArrowIcon/>
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
        ))}
      </Row>
      <Col md={12}>
  <div className="banner-content-bottom d-flex justify-content-center plane-btn">
    <a href="#inquire-now" className="primary-btn4">
      <span>View All Package
      <img src={planeIcon} alt="plane" className="icon ms-2" />
      </span>
    </a>
  </div>
</Col>
    </Container>
  );
};

export default TourTabsSlider;
